export default class OtherToggle {
    private container: HTMLElement;
    private otherTypeInput: HTMLInputElement;
    private otherTypeContainer: HTMLElement;
    private otherUsageInput: HTMLInputElement;
    private otherUsageContainer: HTMLElement;

    constructor(container: HTMLElement) {
        this.container = container;
        this.otherTypeInput = this.container.querySelector("#check-type-other");
        this.otherUsageInput = this.container.querySelector("#check-usage-other");
        this.otherTypeContainer = this.container.querySelector(".other-type");
        this.otherUsageContainer = this.container.querySelector(".other-usage");

        this.registerEventListener(this.otherTypeInput, this.otherTypeContainer);
        this.registerEventListener(this.otherUsageInput, this.otherUsageContainer);
    }

    private registerEventListener(element: HTMLInputElement, container: HTMLElement) {
        element.addEventListener("click", () => {
            if (element.checked) {
                container.classList.add("visible");
            } else {
                container.classList.remove("visible");
            }
        });
    }
}
